var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.ui.layout.header.visible)?_c('v-app-bar',{staticClass:"dense px-6",attrs:{"app":"","flat":"","height":"56px"}},[_c('Header')],1):_vm._e(),_c('v-main',{staticClass:"px-6"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }